import _ from 'lodash';

import { FileDescriptor, MimeTypeBase } from '../../types/entities';
import { MediaAsset } from '../../types/media-assets';
import { MaybeUndef } from '../../types/system';
import { toMimeType } from '../mime-type/mime-type';
import { basename } from '../path/path';

const FOLDER_MIME_TYPE = 'application/vnd.wix-media.dir';

export const normalizeFile = (file: FileDescriptor): MediaAsset => {
  const isFolder = file.mimeType === FOLDER_MIME_TYPE;
  const clientName = basename(file.path);

  return {
    ...file,
    isFolder,
    clientName,
    mimeTypeParsed: toMimeType(file.mimeType),
  };
};

type MediaAssetTypeFilterFn = (asset: MediaAsset) => boolean;
export type MediaAssetTypeFilter = MimeTypeBase | MediaAssetTypeFilterFn;

export const isAssetFitFilter = (
  filter: MaybeUndef<MediaAssetTypeFilter>,
  asset: MediaAsset,
): boolean => {
  if (!filter) {
    return true;
  }

  if (_.isFunction(filter)) {
    return filter(asset);
  }

  return asset.mimeTypeParsed.type === filter;
};
